import React from 'react'

import PatientsTable from 'presentation/hospital/components/PatientsTable'
import { LoadPatients } from 'domain/usecases/patient/load-patients'
import ContainerNew from 'presentation/hospital/components/ContainerNew'

type Props = {
  loadPatients: LoadPatients
}

export default function PatientsLayout({ loadPatients }: Props) {
  return (
    <ContainerNew>
      <PatientsTable loadPatients={loadPatients} />
    </ContainerNew>
  )
}
